import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import iconButton from "../../assets/images/employee/icon-button.svg";
import TableApartments from "./tableApartments";
import FormNew from "./formApartments/fromNew";
import iconExport from "../../assets/images/product/iconExport.svg";
import iconPlus from "../../assets/images/apartment/plus.svg";
import iconFile from "../../assets/images/apartment/Frame.svg";
import PopupImport from "../../components/popup/PopupImport";
// import { useApartment } from "../../hooks/useApartments";
import toast from "react-hot-toast";
import { apartmentCall } from "../../api/apartment";
import { exportFile } from "../../utils/tools";
import { useApartmentManager } from "../../hooks/useApartmentManagers";
import { employeeCall } from "../../api/employee";
import { useSelector } from "react-redux";
const REACT_APP_ROUTE_RATE =
  process.env.REACT_APP_ROUTE_RATE ||
  "MSH_RATE_PRODUCT_AND_APARTMENT_MANAGEMENT";

const columnMappingReverse = {
  "Mã căn hộ": "code",
  "Tên căn hộ": "name",
  "DT đất": "area",
  "DT xây dựng": "builtUpArea",
  "DT tim tường": "grossFloorArea",
  "DT thông thủy": "areaOfWater",
  "Chiều dài": "length",
  "Chiều rộng": "width",
  "Phòng ngủ": "numberOfBedrooms",
  "Phòng VS": "numberOfToilets",
  Hướng: "directionName",
  "Loại hình căn hộ": "apartmentTypeName",
  "Tính chất": "propertyName",
  "Dự án": "projectName",
  "Mã phân khu": "divisionCode",
  "Giá niêm yết": "totalValue",
  "Giá tính PDV": "priceForCommission",
  "Giá tính phí dịch vụ ước tính": "estimatedServiceFeePrice",
  // "Hệ số K": "kRate",
  "Phần trăm thưởng nóng": "hotBonusPercent",
};

const columnPriceMappingReverse = {
  "Mã căn hộ": "code",
  "Giá niêm yết": "totalValue",
  "Giá tính PDV": "priceForCommission",
  "Giá tính phí dịch vụ ước tính": "estimatedServiceFeePrice",
};

const columnRateMappingReverse = {
  "Mã căn hộ": "code",
  "% phí dịch vụ nhận từ CĐT": "commissionFromInvestor",
  "% phí dịch vụ trả cho sale": "commissionToSales",
  "% phí dịch vụ nhận từ đối tác ngoài CĐT": "commissionFromPartner",
};

export default function Apartment() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [paramExport, setParamExport] = useState(null);
  const user = useSelector((state) => state.auth.login?.currentUser);
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupVisiblePrice, setPopupVisiblePrice] = useState(false);
  const [popupVisibleRate, setPopupVisibleRate] = useState(false);
  const [getRoleUser, setGetRoleUser] = useState(false);

  const fetchDataUser = async (id) => {
    try {
      const res = await employeeCall.roleUser(id);
      if (res?.group_role_code) {
        const hasRole = res?.group_role_code
          ?.split(",")
          .includes(REACT_APP_ROUTE_RATE);
        setGetRoleUser(hasRole);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchDataUser(user?.user?._id);
  }, [user?.user?._id]);

  const { refetch, isRefetching, entries, apartmentData } =
    useApartmentManager();

  const handleExport = async () => {
    const checkInColumnMapping = {
      code: "Mã căn hộ",
      name: "Tên căn hộ",
      area: "DT đất",
      builtUpArea: "DT xây dựng",
      grossFloorArea: "DT tim tường",
      areaOfWater: "DT thông thủy",
      length: "Chiều dài",
      width: "Chiều rộng",
      numberOfBedrooms: "Phòng ngủ",
      numberOfToilets: "Phòng VS",
      direction: "Hướng",
      apartmentType: "Loại hình căn hộ",
      property: "Tính chất",
      project: "Dự án",
      division: "Mã phân khu",
      totalValue: "Giá niêm yết",
      priceForCommission: "Giá tính PDV",
      estimatedServiceFeePrice: "Giá tính phí dịch vụ ước tính",
      saleOpeningEvents: "Đợt mở bán",
      // kRate: "Hệ số K",
      hotBonusPercent: "Phần trăm thưởng nóng",
    };

    // if (getRoleUser) {
    //   checkInColumnMapping.commissionFromInvestor = "% phí dịch vụ nhận từ CĐT";
    //   checkInColumnMapping.commissionToSales = "% phí dịch vụ trả cho sale";
    //   checkInColumnMapping.commissionFromPartner =
    //     "% phí dịch vụ nhận từ đối tác ngoài CĐT";
    // }

    if (apartmentData?.length) {
      const data = await apartmentCall.export(
        entries,
        paramExport,
        getRoleUser,
      );
      if (data) {
        exportFile(data, checkInColumnMapping, "bang_quan_ly_can_ho.xlsx");
        toast.success("Download file thành công");
      } else {
        toast.error("Không có dữ liệu");
      }
    } else toast.error("Không có dữ liệu");
  };

  const handleExportV2 = async () => {
    const checkInColumnMapping = {
      code: "Mã sản phẩm",
      projectCode: "Mã dự án",
      saleOpeningEventCode: "Mã đợt mở bán",
      booking: "Trạng thái booking",
      locking: "Trạng thái locking",
      is_hidden: "Đã bán",
      totalValue: "Giá niêm yết",
      priceForCommission: "Giá tính phí dịch vụ",
      estimatedServiceFeePrice: "Giá tính phí dịch vụ ước tính",
      transactionRate: "Tỉ lệ nhận về",
      rateTNSan: "Tỉ lệ thưởng nóng sàn",
      priceTNSan: "Tiền thưởng nóng sàn",
      direction: "Hướng",
      division: "Phân khu",
      apartmentType: "Loại căn hộ",
      property: "Tính chất",
      area: "Diện tích",
      builtUpArea: "Diện tích xây dựng",
      length: "Chiều dài",
      width: "Chiều rộng",
      numberOfBedrooms: "Số phòng ngủ",
      numberOfToilets: "Số phòng vệ sinh",
    };

    if (apartmentData?.length) {
      const data = await apartmentCall.exportV2(entries, paramExport);
      if (data) {
        exportFile(data, checkInColumnMapping, "bang_quan_ly_can_ho_v2.xlsx");
        toast.success("Download file thành công");
      } else {
        toast.error("Không có dữ liệu");
      }
    } else toast.error("Không có dữ liệu");
  };

  const handleExportSample = () => {
    const columnMapping = {
      code: "Mã căn hộ",
      name: "Tên căn hộ",
      area: "DT đất",
      builtUpArea: "DT xây dựng",
      grossFloorArea: "DT tim tường",
      areaOfWater: "DT thông thủy",
      length: "Chiều dài",
      width: "Chiều rộng",
      numberOfBedrooms: "Phòng ngủ",
      numberOfToilets: "Phòng VS",
      directionName: "Hướng",
      apartmentTypeName: "Loại hình căn hộ",
      propertyName: "Tính chất",
      projectName: "Dự án",
      divisionCode: "Mã phân khu",
      totalValue: "Giá niêm yết",
      priceForCommission: "Giá tính PDV",
      estimatedServiceFeePrice: "Giá tính phí dịch vụ ước tính",
      // kRate: "Hệ số K",
      hotBonusPercent: "Phần trăm thưởng nóng",
    };
    const data = [
      {
        code: "AP001",
        name: "Căn hộ APT",
        area: 120,
        builtUpArea: 100,
        grossFloorArea: 20.1,
        areaOfWater: 22.2,
        length: 10,
        width: 12,
        numberOfBedrooms: 3,
        numberOfToilets: 2,
        directionName: "Hướng nam",
        apartmentTypeName: "Hạng sang",
        propertyName: "Loại tính chất 1",
        projectName: "Dự án B",
        divisionCode: "BIET_THU_2",
        totalValue: 2000000000,
        priceForCommission: 50000000,
        estimatedServiceFeePrice: 50000000,
        // kRate: 1.2,
        hotBonusPercent: 5.5,
      },
      {
        code: "CH2",
        name: "Căn hộ 22",
        area: 120,
        builtUpArea: 100,
        grossFloorArea: 20.1,
        areaOfWater: 22.2,
        length: 10,
        width: 12,
        numberOfBedrooms: 3,
        numberOfToilets: 2,
        directionName: "Hướng nam",
        apartmentTypeName: "Hạng sang",
        propertyName: "Loại tính chất 1",
        projectName: "Dự án B",
        divisionCode: "BIET_THU_2",
        totalValue: 2000000000,
        priceForCommission: 50000000,
        estimatedServiceFeePrice: 50000000,
        // kRate: 1.2,
        hotBonusPercent: 5.5,
      },
    ];
    try {
      exportFile(data, columnMapping, "mau_import_san_pham.xlsx");
      toast.success("Download file thành công");
    } catch (error) {
      toast.error("Export lỗi");
      console.log(error);
    }
  };

  const handlePriceExportSample = () => {
    const columnMapping = {
      code: "Mã căn hộ",
      totalValue: "Giá niêm yết",
      priceForCommission: "Giá tính PDV",
      estimatedServiceFeePrice: "Giá tính phí dịch vụ ước tính",
    };
    const data = [
      {
        code: "AP001",
        totalValue: 2000000000,
        priceForCommission: 50000000,
        estimatedServiceFeePrice: 50000000,
      },
      {
        code: "CH2",
        totalValue: 2000000000,
        priceForCommission: 50000000,
        estimatedServiceFeePrice: 50000000,
      },
    ];
    try {
      exportFile(data, columnMapping, "mau_import_gia_san_pham.xlsx");
      toast.success("Download file thành công");
    } catch (error) {
      toast.error("Export lỗi");
      console.log(error);
    }
  };

  const handleRateExportSample = () => {
    const columnMapping = {
      code: "Mã căn hộ",
      commissionFromInvestor: "% phí dịch vụ nhận từ CĐT",
      commissionToSales: "% phí dịch vụ trả cho sale",
      commissionFromPartner: "% phí dịch vụ nhận từ đối tác ngoài CĐT",
    };
    const data = [
      {
        code: "AP001",
        commissionFromInvestor: 1.5,
        commissionToSales: 2.5,
        commissionFromPartner: 3.5,
      },
      {
        code: "CH2",
        commissionFromInvestor: 4.5,
        commissionToSales: 5.5,
        commissionFromPartner: 6.5,
      },
    ];
    try {
      exportFile(data, columnMapping, "mau_import_ti_le_ho_hong_san_pham.xlsx");
      toast.success("Download file thành công");
    } catch (error) {
      toast.error("Export lỗi");
      console.log(error);
    }
  };

  const onSubmitAdd = async (data) => {
    const toastCreate = toast.loading("Đang thêm căn hộ ...");
    try {
      let filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null,
        ),
      );
      await apartmentCall.create(filteredData);

      await refetch();
      onClose();
      toast.success("Thêm thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Quản lý sản phẩm
          </Text>
        </Flex>
        <Flex alignItems={"center"} gap={"16px"}>
          <Button
            w={"176px"}
            h={"44px"}
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            backgroundImage="var(--linear-gradient-excel)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={handleExport}
          >
            <Image src={iconExport} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Xuất exel
            </Text>
          </Button>
          <Button
            w={"176px"}
            h={"44px"}
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            backgroundImage="var(--linear-gradient-excel)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={handleExportV2}
          >
            <Image src={iconExport} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Xuất exel v2
            </Text>
          </Button>
          <Menu>
            <MenuButton
              w={"180px"}
              h={"44px"}
              as={Button}
              backgroundImage="var(--color-button)"
              _hover={{
                filter: "brightness(90%)",
              }}
              _active={{
                filter: "brightness(90%)",
              }}
            >
              <Flex alignItems={"center"} p={"10px 0px 10px 0px"} gap={"8px"}>
                <Image src={iconButton} />
                <Text
                  fontSize={{ base: "15px" }}
                  fontWeight={600}
                  color="var(--color-main)"
                >
                  Sản phẩm mới
                </Text>
              </Flex>
            </MenuButton>
            <MenuList>
              <MenuItem
                onClick={() => {
                  onOpen();
                }}
                gap={"16px"}
                p={"10px 16px"}
                borderBottom={"0.5px solid var(--border-input-employee)"}
                _hover={{
                  filter: "brightness(96%)",
                }}
              >
                <Image src={iconPlus} /> Tạo sản phẩm mới
              </MenuItem>
              <MenuItem
                onClick={() => setPopupVisible(true)}
                gap={"16px"}
                p={"10px 16px"}
                _hover={{
                  filter: "brightness(96%)",
                }}
              >
                <Image src={iconFile} /> Import Sản phẩm
              </MenuItem>
              <MenuItem
                onClick={() => setPopupVisiblePrice(true)}
                gap={"16px"}
                p={"10px 16px"}
                _hover={{
                  filter: "brightness(96%)",
                }}
              >
                <Image src={iconFile} /> Import Giá Sản Phẩm
              </MenuItem>
              {/* {getRoleUser && (
                <MenuItem
                  onClick={() => setPopupVisibleRate(true)}
                  gap={"16px"}
                  p={"10px 16px"}
                  _hover={{
                    filter: "brightness(96%)",
                  }}
                >
                  <Image src={iconFile} /> Import Tỉ lệ phí dịch vụ
                </MenuItem>
              )} */}
            </MenuList>
          </Menu>
        </Flex>
      </Flex>
      <Box mt={{ base: "23px" }}>
        <TableApartments
          isRefetchingWithCreate={isRefetching}
          paramData={setParamExport}
        />
      </Box>
      <FormNew
        isOpen={isOpen}
        onClose={onClose}
        isEdit={false}
        onSubmit={onSubmitAdd}
      />
      {popupVisible && (
        <PopupImport
          isOpen={popupVisible}
          onClose={() => setPopupVisible(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnMappingReverse}
          handleExport={handleExportSample}
          titleAdd="Thêm danh sách căn hộ"
          inputAdd="Nhập danh sách căn hộ"
          type={"apartment"}
          isTypePrice={true}
        />
      )}
      {popupVisiblePrice && (
        <PopupImport
          isOpen={popupVisiblePrice}
          onClose={() => setPopupVisiblePrice(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnPriceMappingReverse}
          handleExport={handlePriceExportSample}
          titleAdd="Thêm danh sách giá căn hộ"
          inputAdd="Nhập danh sách giá căn hộ"
          type={"apartmentPrice"}
          isTypePrice={true}
        />
      )}
      {popupVisibleRate && getRoleUser && (
        <PopupImport
          isOpen={popupVisibleRate}
          onClose={() => setPopupVisibleRate(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnRateMappingReverse}
          handleExport={handleRateExportSample}
          titleAdd="Thêm danh sách tỉ lệ phí dịch vụ"
          inputAdd="Nhập danh sách tỉ lệ phí dịch vụ"
          type={"apartmentRate"}
          isTypePrice={true}
        />
      )}
    </Box>
  );
}
